<div class="container">
  <div class="salesperson-contact-info">
    @if (salesperson) {
      <div class="salesperson-image">
        <va-icon [iconUrl]="iconUrl" [diameter]="60"></va-icon>
      </div>
    }

    <div>
      <div class="salesperson-name">{{ name }}</div>
      <div>{{ title }}</div>
      <div>{{ cityAndState }}</div>
      <div>
        <a href="mailto:{{ email }}">{{ email }}</a>
      </div>
    </div>

    @if (!salesperson) {
      <div class="generic-contact">
        Contact {{ brandName ? 'your ' + brandName : 'a' }} representative today!
      </div>
    }

    <div class="pricing">
      <store-pricing [pricing]="packagePricing" [wrapFrequency]="true"></store-pricing>
      <div class="cta get-it-now-bottom-button">
        @if (salesperson && showGetItNow) {
          <button mat-button (click)="onGetItNowSelected()" class="now-button">
            {{ actionLabel }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
